import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Token } from "./session";
import { rootPath, signInPath } from "./paths";

interface AuthContextType {
  authenticated: boolean;
  createSession: (token: string, callback?: VoidFunction) => void;
  clearSession: (callback?: VoidFunction) => void;
}

const AuthContext = React.createContext<AuthContextType>(null!);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [authenticated, setAuthenticated] = React.useState<boolean>(Token.has());
  const value = {
    authenticated,
    createSession: (token: string, callback?: VoidFunction) => {
      Token.set(token);
      setAuthenticated(true);
      callback && callback();
    },
    clearSession: (callback?: VoidFunction) => {
      Token.remove();
      setAuthenticated(false);
      callback && callback();
    },
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return React.useContext(AuthContext);
}

export function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.authenticated) {
    return <Navigate to={signInPath()} state={{ from: location }} replace />;
  }

  return children;
}

export function RequireNoAuth({ children }: { children: JSX.Element }) {
  const auth = useAuth();

  if (auth.authenticated) {
    return <Navigate to={rootPath()} replace />;
  }

  return children;
}
